
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/black-friday-sale",
      function () {
        return require("private-next-pages/shop/black-friday-sale/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/black-friday-sale"])
      });
    }
  